/* Small progressive accessibility repairs for native theme components. */
(function () {
  'use strict';

  function syncSlide(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    if (hidden) slide.setAttribute('inert', '');
    else slide.removeAttribute('inert');
  }

  function syncSlides(root) {
    (root || document).querySelectorAll('slideshow-slide[aria-hidden]').forEach(syncSlide);
  }

  function makeScrollableRegionsKeyboardReachable() {
    document.querySelectorAll('.sr-product-rail, .sr-tiktok__proof-strip').forEach(function (region) {
      if (region.scrollWidth <= region.clientWidth + 2) return;
      if (!region.hasAttribute('tabindex')) region.setAttribute('tabindex', '0');
      if (!region.hasAttribute('aria-label')) region.setAttribute('aria-label', 'Scrollable product gallery');
    });
  }

  function titlePreviewFrame(root) {
    var frame = (root || document).querySelector && (root || document).querySelector('iframe#PBarNextFrame:not([title])');
    if (frame) frame.title = 'Shopify theme preview controls';
  }

  syncSlides(document);
  makeScrollableRegionsKeyboardReachable();
  titlePreviewFrame(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.target.matches('slideshow-slide')) {
        syncSlide(mutation.target);
      }
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches('slideshow-slide[aria-hidden]')) syncSlide(node);
        syncSlides(node);
        if (node.matches('iframe#PBarNextFrame:not([title])')) node.title = 'Shopify theme preview controls';
        titlePreviewFrame(node);
      });
    });
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
  window.addEventListener('resize', makeScrollableRegionsKeyboardReachable, { passive: true });
})();
